<template>
    <div class="page-layout-forms">
        <div class="page-layout-forms__header">
            <slot name="header"></slot>
        </div>
        <div class="page-layout-forms__content">
            <LayoutContent3Cols>
                <template #sidebar-left>
                    <slot name="sidebar-left"></slot>
                </template>
                <template #content>
                    <slot name="content"></slot>
                </template>
                <template #sidebar-right>
                    <slot name="sidebar-right"></slot>
                </template>
            </LayoutContent3Cols>
        </div>
        <slot name="footer"></slot>
    </div>
</template>
<script>
import LayoutContent3Cols from 'vcomponents/common/layout/content/LayoutContent3Cols.vue';

export default {
    components: {
        LayoutContent3Cols,
    },
};
</script>
<style lang="scss">
body:has(.page-layout-forms) {
    #sellsy_app {
        background-color: var(--colors-common-background-default);
    }
}
</style>
<style lang="scss" scoped>
.page-layout-forms {
    padding: 0 0 var(--spacing-4);

    &__header {
        margin-bottom: var(--spacing-4);

        h1 {
            margin: 0;
        }
    }
}
</style>
